// src/index.js
import React, { Suspense } from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import App from "../src/App";
// Libraries
import { BrowserRouter } from "react-router-dom";
import { LazyMotion, domMax } from "framer-motion";
import { HelmetProvider } from "react-helmet-async"; // Add this import
// i18n - must be imported before App so translations load
import "./i18n/config";
// css
import "./Assets/css/icons.css";
import "./Assets/css/global.css";
import "./Assets/css/pages.css";
import "./index.scss";

// Function to load HLS.js if needed
(function loadHls() {
  if (window.Hls) return; // Skip if already loaded

  const script = document.createElement("script");
  script.src = "https://cdn.jsdelivr.net/npm/hls.js@1.4.12";
  script.async = false; // Important: we want this to load synchronously
  script.crossOrigin = "anonymous";

  // Add it to head for better performance
  document.head.appendChild(script);
})();

// Wrap your app with the necessary providers
const AppWithProviders = () => (
  <Suspense fallback={null}>
    <HelmetProvider>
      <LazyMotion features={domMax}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LazyMotion>
    </HelmetProvider>
  </Suspense>
);

// Get the root element
const rootElement = document.getElementById("root");

// Use hydration if the app was pre-rendered, otherwise do a regular render
if (rootElement.hasChildNodes()) {
  // This means we have pre-rendered content from the server or react-snap
  hydrateRoot(rootElement, <AppWithProviders />);
} else {
  // Normal client-side rendering
  createRoot(rootElement).render(<AppWithProviders />);
}

// Register service worker when DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  // Register service worker after DOM content is loaded
  // It will only register in production due to the check in register()
});
